import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { Tooltip } from '@repo/design-system/components/ds/tooltip/tooltip';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsBulkMovingLocations, selectIsInCreatorMode, selectSelectedMarkerId } from '@repo/store/maps/slices/mapData';
import { useAuth } from '@repo/ui-web/auth/auth-hooks';
import { useCreatorToolOperations } from '../game-map/hooks/useCreatorToolOperations';
import { useLocationInfo } from '../location-info/hooks/useLocationInfo';
export const MoveMapLocation = () => {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    isAuthenticated
  } = useAuth();
  const {
    isMovingLocation,
    startMovingLocation,
    cancelMovingLocation
  } = useCreatorToolOperations();
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const isBulkMovingLocations = useAppSelector(selectIsBulkMovingLocations);
  const selectedMarkerId = useAppSelector(selectSelectedMarkerId);
  const {
    selectedLocation
  } = useLocationInfo();
  let t1;
  if ($[1] !== cancelMovingLocation || $[2] !== isBulkMovingLocations || $[3] !== isMovingLocation || $[4] !== selectedLocation || $[5] !== startMovingLocation || $[6] !== t) {
    t1 = () => {
      if (isBulkMovingLocations) {
        return;
      }
      if (isMovingLocation) {
        cancelMovingLocation();
      } else {
        if (!selectedLocation) {
          toast({
            title: t(_temp),
            variant: "error"
          });
          return;
        }
        toast({
          title: t(_temp2),
          description: t(_temp3),
          variant: "info"
        });
        startMovingLocation(selectedLocation);
      }
    };
    $[1] = cancelMovingLocation;
    $[2] = isBulkMovingLocations;
    $[3] = isMovingLocation;
    $[4] = selectedLocation;
    $[5] = startMovingLocation;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleMoveLocation = t1;
  if (!isInCreatorMode) {
    return null;
  }
  let t2;
  if ($[8] !== t) {
    t2 = t(_temp4);
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = isMovingLocation ? "black" : "white";
  const t4 = !isAuthenticated || !selectedMarkerId || isBulkMovingLocations;
  let t5;
  if ($[10] !== isMovingLocation || $[11] !== t) {
    t5 = isMovingLocation ? t(_temp5) : t(_temp6);
    $[10] = isMovingLocation;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = isMovingLocation ? "orange.600" : "white";
  let t7;
  if ($[13] !== t6) {
    t7 = css({
      background: t6,
      borderRadius: "full",
      "&:not(:focus-visible)": {
        boxShadow: "lg"
      }
    });
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isMovingLocation ? "close" : "drag_indicator";
  let t9;
  if ($[15] !== t8) {
    t9 = <Icon icon={t8} decorative={true} />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleMoveLocation || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t7 || $[22] !== t9) {
    t10 = <IconButton onClick={handleMoveLocation} color={t3} size="lg" disabled={t4} aria-label={t5} className={t7}>{t9}</IconButton>;
    $[17] = handleMoveLocation;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t2) {
    t11 = <Tooltip content={t2}>{t10}</Tooltip>;
    $[24] = t10;
    $[25] = t2;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
function _temp($) {
  return $.no_location_selected;
}
function _temp2($_0) {
  return $_0.moving_pin;
}
function _temp3($_1) {
  return $_1.select_new_location_on_map;
}
function _temp4($_2) {
  return $_2.move_selected_location;
}
function _temp5($_3) {
  return $_3.cancel_moving_location;
}
function _temp6($_4) {
  return $_4.move_selected_location;
}